var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_46",
    "data-name": "Layer 46",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3343",
    "data-name": "Path 3343",
    d: "M23.25,2H5.75A3.75,3.75,0,0,0,2,5.75v17.5A3.75,3.75,0,0,0,5.75,27h17.5A3.75,3.75,0,0,0,27,23.25V5.75A3.75,3.75,0,0,0,23.25,2Zm-1.613,8.363-9.325,9.925a1.268,1.268,0,0,1-1.825,0L7.387,17A1.25,1.25,0,1,1,9.2,15.288l2.2,2.338,8.413-8.95a1.243,1.243,0,0,1,1.825,1.688Z",
    transform: "translate(0)",
    fill: "#e23744"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeader);
export default __webpack_public_path__ + "static/media/leader.34c8392ef3b17356c9a3a919594daabe.svg";
export { ForwardRef as ReactComponent };